import { render, staticRenderFns } from "./PidBatchRow.vue?vue&type=template&id=512d2f31&scoped=true&"
import script from "./PidBatchRow.vue?vue&type=script&lang=js&"
export * from "./PidBatchRow.vue?vue&type=script&lang=js&"
import style0 from "./PidBatchRow.vue?vue&type=style&index=0&id=512d2f31&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512d2f31",
  null
  
)

export default component.exports